module.exports = __webpack_public_path__ + "static/media/air-airplane-army-svgrepo-com.aa0e2915.svg";